<script setup lang="ts">

import { ref } from "vue";
import { useRegistry, useResolveLabel } from "@hantera/portal-app";

const props = defineProps<{
  inventoryKey: string
}>()

const registry = useRegistry()
const resolveLabel = useResolveLabel()

const inventory = await registry.getInventory(props.inventoryKey)

const label = ref()

if (inventory) {
  label.value = resolveLabel.resolve(inventory.label)
} else {
  label.value = props.inventoryKey
}

</script>

<template>
  {{ label }}
</template>
